import {
  FileText,
  Search,
  ChevronDown,
  Plus
} from "lucide-react"

import styles from "./PageManagementHeader.module.css"

const PageManagementHeader = ({
  handleAdd,
  search = "",
  onSearchChange,
  publishedCount = 0,
  draftCount = 0,
}) => {
  return (
    <div className={styles.shell}>
      <div className={styles.hero}>
        <div className={styles.left}>
          <div className={styles.icon}>
            <FileText size={20} color="#ffffff" />
          </div>

          <div>
            <h1 className={styles.title}>Pages</h1>
            <p className={styles.subtitle}>
              Manage static pages and dynamic content
            </p>
          </div>
        </div>

        <div className={styles.right}>
          <div className={styles.stat}>
            <span className={`${styles.dot} ${styles.green}`} />
            <span>{publishedCount} Published</span>
          </div>

          <div className={styles.stat}>
            <span className={`${styles.dot} ${styles.orange}`} />
            <span>{draftCount} Drafts</span>
          </div>

          <button className={styles.cta} onClick={handleAdd}>
            <Plus size={14} />
            New Page
          </button>
        </div>
      </div>

      <div className={styles.controls}>
        <div className={styles.search}>
          <Search size={16} className={styles.searchIcon} />
          <input
            placeholder="Search by page title or slug"
            className={styles.input}
            value={search}
            onChange={(e) => onSearchChange?.(e.target.value)}
          />
        </div>

        <button className={styles.filter}>
          All Status
          <ChevronDown size={14} className={styles.chevron} />
        </button>
      </div>
    </div>
  )
}

export default PageManagementHeader
